<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>蓄能器管理</p>
    </div>
    <Tabs>
      <TabPane label="全部蓄能器" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary" style="margin-right:5px;">新增蓄能器</Button>
      <Button @click="openModal('delMany')" slot="extra" type="primary" style="margin-right:5px;">批量删除</Button>
      <Button @click="openModal('alterMany')" slot="extra" type="primary">批量修改</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
    >
        <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('newCreate')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新增蓄能器</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="newItem.prefix"
                  style="width:200px;"
                  @change="getValidRange"
                />
              </td>
            </tr>
            <tr>
              <td>可选编号范围：</td>
              <td>
                <div style="width:300px;word-wrap:break-word;">
                  {{newItem.validRange}}
                </div>
                
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="newItem.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="newItem.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
            <tr>
              <td>合同执行单编号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.sale_exenum"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>阀批号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.valve_batch"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>皮囊批号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.bladder_batch"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>连接类型：</td>
              <td>
                <select v-model="newItem.lfmod" style="width:200px;">
                  <option value="L">L(螺纹)</option>
                  <option value="F">F(法兰)</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>介质类型：</td>
              <td>
                <select v-model="newItem.medium" style="width:200px;">
                  <option value="Y">Y(液压油)</option>
                  <option value="R">R(乳化液)</option>
                  <option value="M">M()</option>
                  <option value="E">E()</option>
                  <option value="S">S()</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>监检编号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.suin"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>编号facode：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.facode"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>客户名称：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.customer"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>密封及动作性能试验日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="newItem.pressuretestdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>完工日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="newItem.comdate"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')" :disabled="accCreateValid" >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.delMany"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('delMany')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>批量删除蓄能器</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="delItem.prefix"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="delItem.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="delItem.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="delManySubmit('delMany')" :disabled="delManyValid" >提交</Button>
        <Button size="large" @click="closeModal('delMany')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterMany"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('alterMany')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>批量修改蓄能器</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>选择工序：</td>
              <td>
                <select v-model="manyAcc.process" style="width:200px;" @change="getAlterValidRange">
                  <option :value="ele.value" v-for="ele in processList" :key="ele.value+'process'">{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="manyAcc.prefix"
                  style="width:200px;"
                  @change="getAlterValidRange"
                />
              </td>
            </tr>
            <tr>
              <td>可选编号范围：</td>
              <td>
                <div style="width:300px;word-wrap:break-word;">
                  {{manyAcc.validRange}}
                </div>
                
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="manyAcc.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="manyAcc.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
            <tr>
              <td>日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="manyAcc.targetdate"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterManySubmit('alterMany')" :disabled="alterManyValid" >提交</Button>
        <Button size="large" @click="closeModal('alterMany')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.accAlter"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('accAlter')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>更新内容</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>当前编号：</td>
              <td>
                {{acc.pronum}}
              </td>
            </tr>
            <tr>
              <td>合同执行单编号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.sale_exenum"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>阀批号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.valve_batch"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>皮囊批号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.bladder_batch"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>连接类型：</td>
              <td>
                <select v-model="acc.lfmod" style="width:200px;">
                  <option value="L">L(螺纹)</option>
                  <option value="F">F(法兰)</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>介质类型：</td>
              <td>
                <select v-model="acc.medium" style="width:200px;">
                  <option value="Y">Y(液压油)</option>
                  <option value="R">R(乳化液)</option>
                  <option value="M">M()</option>
                  <option value="E">E()</option>
                  <option value="S">S()</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>监检编号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.suin"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>编号facode：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.facode"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>客户名称：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="acc.customer"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>密封及动作性能试验日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="acc.pressuretestdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>完工日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="acc.comdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea
                  type="text"
                  placeholder=""
                  v-model="acc.remark"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="accAlterSubmit('accAlter')" >提交</Button>
        <Button size="large" @click="closeModal('accAlter')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue(){
    return {
        prefix:"",
        validRange:"",
        snBegin:"",
        snEnd:"",
        sale_exenum:"",
        valve_batch:"",
        bladder_batch:"",
        lfmod:"L",
        medium:"Y",
        suin:"",
        facode:"",
        customer:"",
        pressuretestdate:null,
        comdate:null
    };
}

function manyAccAlter(){
    return {
        process:"",
        prefix:"",
        validRange:"",
        snBegin:"",
        snEnd:"",
        targetdate:null
    };
}

function accAlter(){
  return {
    sale_exenum:"",
    valve_batch:"",
    bladder_batch:"",
    lfmod:"L",
    medium:"Y",
    suin:"",
    facode:"",
    customer:"",
    pressuretestdate:null,
    comdate:null,
    remark:""
  };
}

export default {
  name: "shell",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "accList",
      update_count: 0,
      modalValue:{
          newCreate:false,
          accAlter:false,
          delMany:false,
          alterMany:false,
      },
      newItem:itemValue(),
      matList:[],
      matListTotal:[],
      heatList:[],
      processList:[],
      pressureDict:{},
      volumeDict:{},
      acc:accAlter(),
      delItem:itemValue(),
      manyAcc:manyAccAlter(),
      columnsFormatData: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(shellExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "编号",
          key: "pronum",
          align: "center",
          width:90
        },
        {
          title: "合同执行单号",
          key: "sale_exenum",
          width: 120,
          align: "center"
        },
        {
          title: "油阀批号",
          key: "valve_batch",
          width: 85,
          align: "center"
        },
        {
          title: "皮囊批号",
          key: "bladder_batch",
          width: 85,
          align: "center"
        },
        {
          title: "连接形式",
          key: "lfmod",
          width: 85,
          align: "center"
        },
        {
          title: "介质",
          key: "medium",
          width: 65,
          align: "center"
        },
        {
          title: "监检编号",
          key: "suin",
          width: 85,
          align: "center"
        },
        {
          title: "facode编号",
          key: "facode",
          width: 85,
          align: "center"
        },
        {
          title: "油压日期",
          key: "pressuretestdate",
          width: 100,
          align: "center"
        },
        {
          title: "完工日期",
          key: "comdate",
          width: 100,
          align: "center"
        },
        {
          title: "客户名称",
          key: "customer",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 140,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.modalValue.accAlter = true;
                      this.acc = params.row;
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
        /*{
          title: "材质",
          key: "grade",
          width: 75,
          align: "center"
        },
        {
          title: "外径*厚度",
          width: 110,
          align: "center",
          render:(h,params)=>{
              return h('p',
              {},
              params.row.diameter+'*'+params.row.thickness

              );
          },
        },
        {
          title: "工序流程",
          key: "flow_name",
          align: "center"
        },
        
        
        
        
        {
          title: "热处理工艺",
          key: "des",
          align: "center",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "solid",
                    size: "small"
                  },
                  style: {},
                  on: {
                    click: () => {
                      this.linkTo(params.row.file_url);
                    }
                  }
                },
                "下载"
              )
            ]);
          }
        }*/
      ]
    };
  },
  computed:{
    accCreateValid:function(){
      if(this.newItem.prefix!==""&&
         this.newItem.snBegin!==""&&
        this.newItem.snEnd!==""
         ){
           return false;
         }else{
           return true;
         }
    },
    delManyValid:function(){
      if(this.delItem.prefix!==""&&
         this.delItem.snBegin!==""&&
        this.delItem.snEnd!==""
         ){
           return false;
         }else{
           return true;
         }
    },
    alterManyValid:function(){
      if(this.manyAcc.prefix!==""&&
         this.manyAcc.snBegin!==""&&
        this.manyAcc.snEnd!==""&&
        this.manyAcc.targetDate!==null
         ){
           return false;
         }else{
           return true;
         }
    }

  },
  created(){
    this.getStaticOptionsData();
  },
  methods: {
    getStaticOptionsData(){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'accOption',
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.processList = response.data.res_record.processList;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getValidRange(){
      if(this.newItem.prefix){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'newManyAccValidRange',
          item:this.newItem
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.newItem.validRange = response.data.res_record.validRange;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
      }
    },
    getAlterValidRange(){
      if(this.manyAcc.prefix){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'alterAccValidRange',
          item:this.manyAcc
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.manyAcc.validRange = response.data.res_record.validRange;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
      }
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "蓄能器：" +
          value.pronum +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.pronum);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delAcc",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    newCreateSubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "createAcc",
          item: this.newItem   
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("新建成功！");
            this.newItem = itemValue();
            this.closeModal(value);
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    delManySubmit(value){
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delManyAcc",
          item: this.delItem
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("删除成功！");
            this.closeModal(value);
            this.delItem = itemValue();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    accAlterSubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "accAlter",
          item: this.acc
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this.acc = accAlter();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    alterManySubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "alterManyAcc",
          item: this.manyAcc
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this.manyAcc = manyAccAlter();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input,.cr-form select{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}

textarea{
  padding: 5px;
}
</style>